import React from 'react'

const About = () => {
  return (
    <section className='section about-section'>
        <h1 className='section-title'>about us</h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem, impedit temporibus repellat rerum ea doloremque. 
        Quis doloribus magnam voluptatum, in deleniti repellendus consequuntur nam 
        reprehenderit facilis repellat deserunt officiis nemo excepturi atque alias, 
        odit, esse cum vitae quo nihil earum.</p>
    </section>
  )
}

export default About